export default "__VITE_ASSET__DVkLQWOz__"